import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { StateSummaryDataTable } from '../dashboard/StateSummary/index';
import { DEV_URL, rget } from '../../utils/requests';
import PageTitle from '../../components/PageTitle/index';
import Div from 'components/Div';

const DashboardPage = () => {
    const emptyStateSummary = { licenseDetails: [] };
    const [stateSummaryData, setStateSummaryData] = useState(emptyStateSummary);
    const [loadingStateSummaryData, setLoadingStateSummaryData] = useState(false);
    
    useEffect(() => {
        document.title = "DataHub - Licenses";
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoadingStateSummaryData(true);
            try {
                const apiCallResponse = await rget(
                    `${DEV_URL}/api/License/GetStateWiseLicenseCount`
                );
                setStateSummaryData(apiCallResponse?.data || emptyStateSummary);
            } catch (error) {
                console.error('Error fetching state wise license count:', error);
                setStateSummaryData(emptyStateSummary);
            } finally {
                setLoadingStateSummaryData(false);
            }
        };
        
        fetchData();
    }, []);

    return (
        <>
            <Div className="">
                <div className="">
                    <PageTitle title="Licenses" />
                </div>
            </Div>
                <Card>
                    <div className="p-3">
                        <StateSummaryDataTable 
                            data={stateSummaryData?.licenseDetails || []} 
                            loading={loadingStateSummaryData} 
                        />
                    </div>
                </Card>
        </>
        );
};

export default DashboardPage;
